import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';

import {
  postVerify,
  type PostVerifyParams,
  type PostVerifyResponse,
} from '@services/AuthService';

export type UsePostVerifyParams = {
  mutationOptions?: SWRMutationConfiguration<
    PostVerifyResponse,
    unknown,
    string,
    PostVerifyParams,
    PostVerifyResponse
  >;
};

export const postVerifyMutationKey = 'post-verify';

export const usePostVerify = ({
  mutationOptions,
}: UsePostVerifyParams = {}) => {
  const { trigger, ...swrResponse } = useSWRMutation<
    PostVerifyResponse,
    unknown,
    string,
    PostVerifyParams
  >(postVerifyMutationKey, (_url, { arg }) => postVerify(arg), mutationOptions);

  return {
    trigger,
    ...swrResponse,
  };
};
